export default "__VITE_PUBLIC_ASSET__8c7cd310__"